export default "__VITE_ASSET__63fe4414__"